import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-761e525d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title wow animate__backInDown" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_3 = {
  class: "top",
  id: "contactus"
}
const _hoisted_4 = { class: "left wow animate__backInLeft" }
const _hoisted_5 = { class: "right wow animate__backInRight" }
const _hoisted_6 = { class: "address" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "地址：厦门市集美区灌口镇集美北大道安仁产业园1068-17号7楼", -1))
const _hoisted_8 = { class: "address" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 网址：https://www.rekeymed.com", -1))
const _hoisted_10 = { class: "address" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 电话：0592-7272801", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "address" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont" }, ""),
  /*#__PURE__*/_createElementVNode("span", null, " 邮箱：contact@rekeymed.com ")
], -1))
const _hoisted_13 = {
  class: "cooperation-box",
  id: "cooperation"
}
const _hoisted_14 = { class: "cooperation-banner" }
const _hoisted_15 = { class: "cooperation-content wow animate__backInLeft" }
const _hoisted_16 = {
  class: "wow animate__backInRight",
  alt: ""
}

import type { FormInstance, FormRules } from 'element-plus'
import { ElMessage } from 'element-plus'
import { onMounted, ref, reactive } from 'vue'
import WOW from 'wow.js'
import { submitMessage } from '@/api/product'

interface RuleForm {
  name: string
  company: string
  email: string
  phone: string
  topic: string
  content: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const ruleFormRef = ref<FormInstance>()
const submitting = ref(false)

const form = reactive<RuleForm>({
  name: '',
  company: '',
  email: '',
  phone: '',
  topic: '',
  content: '',
})

const checkNumber = (_rule, value, callback) => {
  const phoneNumberPattern = /^[\d-]+$/
  if (!value) {
    callback()
  } else if (!phoneNumberPattern.test(String(value).trim())) {
    callback(new Error('电话号码格式不正确，请重新输入'))
  } else {
    callback()
  }
}

const checkContent = (_rule, value, callback) => {
  const text = String(value ?? '').trim()
  if (!text) {
    callback(new Error('请填写留言内容'))
  } else if (text.length < 5) {
    callback(new Error('留言内容至少 5 个字'))
  } else {
    callback()
  }
}

const rules = reactive<FormRules<RuleForm>>({
  name: [
    { required: true, message: '请填写姓名', trigger: 'blur' },
    { whitespace: true, message: '请填写姓名', trigger: 'blur' },
  ],
  content: [
    { required: true, message: '请填写留言内容', trigger: 'blur' },
    { validator: checkContent, trigger: 'blur' },
  ],
  phone: [
    { required: true, message: '请填写电话号码', trigger: 'blur' },
    { whitespace: true, message: '请填写电话号码', trigger: 'blur' },
    { validator: checkNumber, trigger: 'blur' },
  ],
})

const resetForm = () => {
  form.name = ''
  form.company = ''
  form.email = ''
  form.phone = ''
  form.topic = ''
  form.content = ''
  ruleFormRef.value?.clearValidate()
}

const onSubmit = async (formEl: FormInstance | undefined) => {
  if (!formEl || submitting.value) return
  await formEl.validate(async (valid) => {
    if (!valid) return
    submitting.value = true
    try {
      const response = await submitMessage({
        name: form.name.trim(),
        company: form.company.trim(),
        email: form.email.trim(),
        phone: form.phone.trim(),
        topic: form.topic.trim(),
        desc: form.content.trim(),
      })
      if (response.data.status === 'success') {
        ElMessage.success(response.data.msg)
        resetForm()
      } else {
        ElMessage.error(response.data.msg || '提交失败')
      }
    } catch (error) {
      ElMessage.error('提交失败，请稍后重试')
    } finally {
      submitting.value = false
    }
  })
}

onMounted(() => {
  new WOW().init()
})


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_LocationFilled = _resolveComponent("LocationFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Promotion = _resolveComponent("Promotion")!
  const _component_PhoneFilled = _resolveComponent("PhoneFilled")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('Contact us1')), 1),
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('Contact us')), 1),
      _hoisted_2
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_form, {
          model: form,
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          "inline-message": true,
          rules: rules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, {
              justify: "space-around",
              align: "middle"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  xs: 20,
                  sm: 12,
                  md: 12,
                  lg: 12,
                  xl: 12
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { prop: "name" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: form.name,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.name) = $event)),
                          placeholder: "姓名",
                          required: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  xs: 20,
                  sm: 12,
                  md: 12,
                  lg: 12,
                  xl: 12
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { prop: "company" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: form.company,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.company) = $event)),
                          placeholder: "公司/单位"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, {
              justify: "space-around",
              align: "middle"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  xs: 20,
                  sm: 12,
                  md: 12,
                  lg: 12,
                  xl: 12
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { prop: "email" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: form.email,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.email) = $event)),
                          placeholder: "联系邮箱"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  xs: 20,
                  sm: 12,
                  md: 12,
                  lg: 12,
                  xl: 12
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { prop: "phone" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: form.phone,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.phone) = $event)),
                          placeholder: "电话",
                          required: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, {
              justify: "space-around",
              align: "middle"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  xs: 20,
                  sm: 24,
                  md: 24,
                  lg: 24,
                  xl: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { prop: "topic" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: form.topic,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.topic) = $event)),
                          placeholder: "主题/关键字"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, {
              justify: "space-around",
              align: "middle"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  xs: 20,
                  sm: 24,
                  md: 24,
                  lg: 24,
                  xl: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "content",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: form.content,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.content) = $event)),
                          type: "textarea",
                          rows: 8,
                          placeholder: "留言内容（必填）",
                          maxlength: "1024",
                          "show-word-limit": ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  loading: submitting.value,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (onSubmit(ruleFormRef.value)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("确认提交")
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_icon, {
            size: "13",
            style: {"color":"#004f9b"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LocationFilled)
            ]),
            _: 1
          }),
          _createTextVNode(),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_icon, {
            size: "13",
            style: {"color":"#004f9b"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Promotion)
            ]),
            _: 1
          }),
          _hoisted_9
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_icon, {
            size: "13",
            style: {"color":"#004f9b"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PhoneFilled)
            ]),
            _: 1
          }),
          _createTextVNode(),
          _hoisted_11
        ]),
        _hoisted_12
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_el_row, {
          justify: "space-evenly",
          align: "middle",
          style: {"z-index":"2"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              xs: 20,
              sm: 20,
              md: 20,
              lg: 12,
              xl: 12
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("h1", null, _toDisplayString(_ctx.$t('Business Cooperation')), 1),
                  _createElementVNode("h1", null, _toDisplayString(_ctx.$t('Choose Partner')), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              xs: 20,
              sm: 20,
              md: 20,
              lg: 12,
              xl: 12
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("img", _hoisted_16, null, 512), [
                  [_directive_lazy, require('@/assets/cooperation_banner.jpg')]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})